import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/base/household/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/base/household/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/base/household/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/base/household/submit', params, options);

export const update = (params, options) =>
  request.post('/api/base/household/submit', params, options);
